exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.md-list[data-v-795d0c7f] {\n  width: 320px;\n  max-width: 100%;\n  display: inline-block;\n  vertical-align: top;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/views/integration/integrated-facilities.vue"],"names":[],"mappings":";AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,sCAAsC;CAAE","file":"integrated-facilities.vue","sourcesContent":[".md-list {\n  width: 320px;\n  max-width: 100%;\n  display: inline-block;\n  vertical-align: top;\n  border: 1px solid rgba(0, 0, 0, 0.12); }\n"],"sourceRoot":""}]);

// exports
